// Nouvelle version en ligne : l'app ajoutée à l'écran d'accueil (iPhone surtout) reprend là où elle était, sans se
// recharger, et garderait l'ancienne version des heures après une mise en ligne (Idries ne trouvait ni la prospection ni
// les boutons du score juste après une mise en ligne). /version.txt (jamais en cache, écrit par deploy/update.sh) dit la
// version servie : quand elle change, l'app se recharge au retour au premier plan ou au changement d'écran suivant,
// jamais pendant une saisie ni une fiche ouverte. En développement (pas de /version.txt), rien ne se passe.
const VERSION_URL = '/version.txt';
const CHECK_EVERY = 60_000;

let loaded: string | null = null;
let pending = false;
let lastCheck = 0;

/** La version servie (« 16b4a2a »), ou null si le fichier manque ou ne ressemble pas à une révision. */
async function served(): Promise<string | null> {
  try {
    const r = await fetch(VERSION_URL, { cache: 'no-store' });
    if (!r.ok) return null;
    const v = (await r.text()).trim();
    return /^[0-9a-f]{7,40}$/.test(v) ? v : null;
  } catch { return null; }
}

/** Une saisie en cours ou une fiche ouverte : on ne recharge pas sous les doigts. */
const busy = (): boolean => !!document.querySelector('.sheet')
  || !!document.activeElement?.matches?.('input, textarea, select, [contenteditable]:not([contenteditable=false])');

async function check(): Promise<void> {
  if (Date.now() - lastCheck < CHECK_EVERY) return;
  lastCheck = Date.now();
  const v = await served();
  if (!v) return;
  if (!loaded) { loaded = v; return; }
  if (v !== loaded) pending = true;
}

const reloadIfSafe = (): void => { if (pending && !busy()) location.reload(); };

/** Une fois au démarrage. */
export function watchAppUpdates(): void {
  void served().then(v => { loaded = v; lastCheck = Date.now(); });
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') void check().then(reloadIfSafe);
  });
  window.addEventListener('hashchange', () => { if (pending) reloadIfSafe(); else void check(); });
}
